import { Col, Input } from "reactstrap";
import { useAppDispatch } from "../../../../../reduxToolkit/hooks";
import { filterSortBy } from "../../../../../reduxToolkit/reducers/eCommerce/filterSlice";

// This component renders a dropdown menu for sorting the products by different criteria.
const SortOptions = () => {
  const dispatch = useAppDispatch();

  return (
    <Col md="6" className="text-sm-end">
      <span className="f-w-500 m-r-5">{"Showing Products 1 - 24 Of 200 Results"}</span>
      <div className="select2-drpdwn-product d-inline-block">
        <Input type="select" className="form-control btn-square" name="select" onChange={(event) => dispatch(filterSortBy(event.target.value))}>
          <option value="Featured">{"Featured"}</option>
          <option value="LowestPrices">{"Lowest Prices"}</option>
          <option value="HighestPrices">{"Highest Prices"}</option>
        </Input>
      </div>
    </Col>
  );
};
export default SortOptions;
